import type { ServerSuggestions } from '@atlassian/jira-issue-internal-field-select/src/common/select-inline-edit/select-field/types.tsx';

// This is for the case where customers have many number of versions that will render so many dropdown items
// that makes browser frozen. https://getsupport.atlassian.com/browse/PCS-121596 https://getsupport.atlassian.com/browse/PCS-48395
export const MAX_OPTIONS_PER_CATEGORY = 20;
export const prefilterAndLimitItems = (
	data: ServerSuggestions,
	inputQueryStr: string,
): ServerSuggestions =>
	data.map((categoryData) => ({
		...categoryData,
		items: categoryData.items
			.filter((x) => x.content.toLowerCase().includes(inputQueryStr.toLowerCase()))
			// apply sort to ensure that exact matches are not sliced off
			.sort(
				(a, b) =>
					Number(b.content.toLowerCase() === inputQueryStr.toLowerCase()) -
					Number(a.content.toLowerCase() === inputQueryStr.toLowerCase()),
			)
			.slice(0, MAX_OPTIONS_PER_CATEGORY),
	}));
